/**
 * ScrollToTop — scrolls window to top whenever the route path changes.
 *
 * React Router (BrowserRouter) preserves the browser scroll position between
 * client-side navigations by default. That means clicking a CTA on the home
 * page while scrolled down would open the next page ALREADY scrolled — so
 * the new page's title appears hidden BEHIND the sticky header. This helper
 * resets scroll to (0,0) on every path change, ensuring every page opens at
 * the top with its title visible below the header.
 *
 * Behavior:
 *   - Runs on every `pathname` change.
 *   - Instant (no smooth scroll) to avoid flashing content mid-transition.
 *   - Ignores hash-only changes (so in-page anchors keep working).
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Fire on next tick so the new page has mounted before scrolling.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
